import React, { useState, useEffect } from "react";
import "./styles/index.less";
import { Form, Input, Button, message, Col, Result, Row } from "antd";
import lock from "../../assets/iconshare/padlock.png";
import { useNavigate } from "react-router-dom";
import { api_forgotPassword, get_all_user } from "../../services/user";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

type Props = {};

const ForgotPass = (props: Props) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [isSubmitForgot, setIsSubmitForgot] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const [emailList, setEmailList] = useState<string[]>([]);

  const success = () => {
    messageApi.open({
      type: "success",
      content: "The email has been sent successfully.",
      duration: 5,
    });
  };

  const error = () => {
    messageApi.open({
      type: "error",
      content: "Please input your email!",
      duration: 5,
    });
  };

  const onFinish = async (values: any) => {
    try {
      if (!values.email) {
        message.error("Please input your email!");
        return;
      }

      if (!emailList.includes(values.email)) {
        message.error("This email is not registered in the system.");
        return;
      }

      const data = {
        email: values.email,
        username: "test forget",
        url: "/user/confirmpassword",
      };

      const res = await api_forgotPassword(data);

      if (res.status === true) {
        success();
        setUserEmail(form.getFieldValue("email"));
        setIsSubmitForgot(true);
      } else {
        console.error("Failed to send reset password email.");
      }
    } catch (e) {
      console.error(e);
      console.error("An unexpected error occurred.");
    }
  };

  const getUserEmail = async () => {
    try {
      const res = await get_all_user();
      const emails = res.result.map((user: any) => user.email);
      setEmailList(emails);
    } catch (e) {
      console.error("Error fetching user emails:", e);
    }
  };

  useEffect(() => {
    getUserEmail();
  }, []);

  return (
    <div>
      {isSubmitForgot ? (
        <div style={{ padding: "40px 0px 10px 0px" }}>
          <Row align={"middle"} justify={"center"}>
            <Col xs={18} sm={18} md={20} lg={16} xl={16}>
              <Result
                status="success"
                title={t("A password reset link has been sent to your email")}
                subTitle={
                  <span style={{ fontSize: "18px" }}>
                    {t(
                      "An email has been sent to your email address. Check your email account inbox and click the reset link",
                    )}{" "}
                    {userEmail}
                  </span>
                }
                extra={[
                  <Button
                    type="link"
                    key="console"
                    onClick={async () => {
                      navigate("/");
                    }}
                  >
                    <ArrowLeftOutlined /> {t("Home page")}
                  </Button>,
                ]}
              />
            </Col>
          </Row>
          <Row align={"middle"} justify={"center"}>
            <Col></Col>
          </Row>
          <Row align={"middle"} justify={"center"}>
            <Col></Col>
          </Row>
        </div>
      ) : (
        <div style={{ padding: "40px 0px 10px 0px" }}>
          <Row align={"middle"} justify={"center"}>
            <Col>
              <img
                src={lock}
                style={{ width: "100px", color: "#1890ff", marginBottom: 20 }}
              />
            </Col>
          </Row>
          <Row align={"middle"} justify={"center"}>
            <Col>
              <p style={{ fontSize: "35px", fontWeight: "bold" }}>
                {t("Forgot password")}
              </p>
            </Col>
          </Row>
          <Row align={"middle"} justify={"center"}>
            <Col xs={18} sm={18} md={20} lg={16} xl={16}>
              <p
                style={{
                  fontSize: "18px",
                  marginBottom: "10px",
                  textAlign: "center",
                }}
              >
                {t(
                  "Please enter the email address you used to sign up for your AI Benchmark Account",
                )}
              </p>
              <p
                style={{
                  fontSize: "18px",
                  marginBottom: "10px",
                  textAlign: "center",
                }}
              >
                {t("We will send you an email to reset your password")}
              </p>
            </Col>
          </Row>

          <Form
            form={form}
            name="validateOnly"
            layout="vertical"
            autoComplete="off"
            initialValues={{ autoLogin: true, email: "" }}
            onFinish={onFinish}
            onFinishFailed={onFinish}
          >
            <Row align={"middle"} justify={"center"} style={{ marginTop: 20 }}>
              <Col xs={16} sm={12} md={10} lg={6} xl={6}>
                <Form.Item
                  label={t("Email") + " * "}
                  name="email"
                  rules={[
                    {
                      type: "email",
                      message: "The input is not a valid e-mail",
                    },
                  ]}
                >
                  <Input placeholder="Email" />
                </Form.Item>
              </Col>
            </Row>
            <Row align={"middle"} justify={"center"}>
              <Col xs={16} sm={12} md={10} lg={6} xl={6}>
                <Form.Item>
                  {contextHolder}
                  <Button
                    size="large"
                    style={{ backgroundColor: "#00215E", borderColor: "#00215E", borderRadius: 8 , color:"#ffffff" }}
                    htmlType="submit"
                    className="reset-password-form-button"
                  >
                    {t("Reset Password")}
                  </Button>
                </Form.Item>
              </Col>
            </Row>
            <Row align={"middle"} justify={"center"}>
              <Col>
                <Button onClick={() => navigate("/")} type="link">
                  <ArrowLeftOutlined /> {t("Back to Login")}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      )}
    </div>
  );
};

export default ForgotPass;
